import { LoaderSize, LoadingOverlay } from '@ardoq/loader';

import React from 'react';

const LoadingOverlayComponent = () => (
  <LoadingOverlay
    loaderSize={LoaderSize.MEDIUM}
    style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
  />
);

export { LoadingOverlayComponent };
